import React from 'react';

import { useEffect, useState } from 'react';

import { Button } from '../../components/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';

import { CtaBlock } from '../../components/CtaBlock';
import { Footer } from '../../components/Footer';
import { Header } from '../../components/Header';
import { HeaderPage } from '../../components/HeaderPage';
import './style.css';

import Carousel from 'react-bootstrap/Carousel';

import PreviewBox from '../../components/PreviewBox/PreviewBox';

import ResourceStore from '../../stores/ResourceStore';

import ScrollToHashElement from '@cascadia-code/scroll-to-hash-element';

export const DasProjektDesktop = ({ shareFeedbackEmailAddress }) => {
    const [index, setIndex] = useState(0);

    const resourceStore = ResourceStore((state) => state);

    useEffect(() => {
        resourceStore.loadForFooterTeaser();

        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (null == resourceStore.footerPortalResources) {
        return null;
    }

    return (
        <div className="das-projekt-desktop">
            <ScrollToHashElement />

            <Header
                className="design-component-instance-node-3"
                style="desktop"
                shareFeedbackEmailAddress={shareFeedbackEmailAddress}
                logoDimensions={{
                    height: 64 * 1.8 + 'px',
                    width: 104 * 1.8 + 'px',
                }}
            />

            <HeaderPage
                align="left"
                background="default"
                breadcrumbLinkText="Über Uns"
                breakpoint="desktop"
                className="header-page-2"
                text="Wo Forschung und Praxis zusammenkommt."
                title="Willkommen bei duo (digital und offen)"
            />
            <div className="content-wrapper">
                <div className="content-4">
                    <div className="div-7">
                        <div className="div-8" id="die_mission">
                            <div className="text-wrapper-11">Die Mission</div>
                            <p className="text-wrapper-12">
                                Die digitale Transformation erfordert von
                                Lehrpersonen, dass sie fundierte Entscheidungen
                                im digital-gestützten Unterricht treffen und die
                                digitale Souveränität ihrer Schüler:innen
                                fördern. Auf duo bieten wir für die
                                Lehrkräftebildung freie, digital-gestützte
                                Unterrichtskonzepte, Erklärvideos sowie
                                Kompaktberichte aktueller Forschungsergebnisse
                                zum Lehren mit und über digitale Technologien
                                an. In unserer Arbeit legen wir hohe Standards
                                an unsere Angebote an.
                            </p>
                        </div>
                    </div>

                    <div
                        className="carousel-arrow"
                        style={{ display: 'inline-flex', float: 'right' }}
                    >
                        <Button
                            className="button-4-carousel"
                            status="default"
                            style="secondary"
                            textLink={
                                <FontAwesomeIcon
                                    style={{ height: '4em' }}
                                    icon={faCaretLeft}
                                    fixedWidth
                                />
                            }
                            onClick={() => {
                                setIndex(
                                    0 > index - 1
                                        ? resourceStore.footerPortalResources
                                              .length - 1
                                        : index - 1,
                                );
                            }}
                        />
                    </div>

                    <div className="div-9">
                        <div className="video-wrapper">
                            <div style={{ alignItems: 'center' }}>
                                {/*<iframe width="560" height="315" src="https://www.youtube.com/embed/Yn8MNy2Jp18?si=YSOQhafXhU3qMT-G" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                 */}
                                <Carousel
                                    data-bs-theme="dark"
                                    fade
                                    indicators={true}
                                    controls={false}
                                    activeIndex={index}
                                >
                                    {resourceStore.footerPortalResources.map(
                                        (resource, i) => {
                                            return (
                                                <Carousel.Item
                                                    style={{
                                                        display: 'grid',
                                                        'grid-template-columns':
                                                            'repeat(2, 1fr)',
                                                    }}
                                                >
                                                    <PreviewBox
                                                        element={resource}
                                                        i={i}
                                                        showDate={false}
                                                        height={'620px'}
                                                        minWidth={'100px'}
                                                    />
                                                </Carousel.Item>
                                            );
                                        },
                                    )}
                                </Carousel>
                            </div>
                        </div>
                    </div>

                    <div className="carousel-arrow" style={{ paddingLeft: 0 }}>
                        <Button
                            className="button-4-carousel"
                            status="default"
                            style="secondary"
                            textLink={
                                <FontAwesomeIcon
                                    style={{ height: '4em' }}
                                    icon={faCaretRight}
                                    fixedWidth
                                />
                            }
                            onClick={() => {
                                setIndex(
                                    resourceStore.footerPortalResources
                                        .length <=
                                        index + 1
                                        ? 0
                                        : index + 1,
                                );
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="content-wrapper">
                <div className="content-5">
                    <div className="div-10">
                        <div className="div-11" id="what_you_can_find">
                            <p className="text-wrapper-11">
                                Was finden Sie auf dem Portal?
                            </p>
                            <p className="text-wrapper-12">
                                Wir bieten wissenschaftlich geprüfte Materielien
                                über aktuelle Forschungsergebnisse sowie
                                Angebote zur Weiterbildung zu Themen rund um
                                Digitalisierung:
                            </p>
                        </div>
                    </div>
                    <div className="div-14">
                        <CtaBlock
                            className="design-component-instance-node-3"
                            showLink={false}
                            stateProp="default"
                            style="default"
                            text="Wir bieten wissenschaftlich geprüfte, digital-gestützte Unterrichtskonzepte aus unterschiedlichen Fächern."
                            title="Unterrichtskonzepte"
                        />
                        <CtaBlock
                            className="design-component-instance-node-3"
                            showLink={false}
                            stateProp="default"
                            style="default"
                            text="Wir bringen Forschung auf den Punkt und informieren über aktuelle Ergebnisse im Themenbereich Digitalisierung."
                            title="Kompaktberichte"
                        />

                        <CtaBlock
                            className="design-component-instance-node-3"
                            showLink={false}
                            stateProp="default"
                            style="default"
                            text="Mit unseren Erklärvideos geben wir einen Einstieg in die Welt der Digitalisierung."
                            title="Erklärvideos"
                        />
                        <CtaBlock
                            className="design-component-instance-node-3"
                            showLink={false}
                            stateProp="default"
                            style="default"
                            text="Wir bündeln aktuelle Fortbildungsangebote zu digitalisierungsbezogenen Themen."
                            title="Fortbildungen"
                        />
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="content-5">
                    <div className="div-10">
                        <div className="div-11">
                            <p className="text-wrapper-12">
                                Wir bieten Informationstexte und Materialien an,
                                die den effektiven Unterricht mit und über
                                digitalen Medien erklären, ermöglichen und
                                exemplifizieren:
                            </p>
                        </div>
                    </div>
                    <div className="quote">
                        <div className="frame-17">
                            <div className="team-member">
                                <div className="image">
                                    <div className="image-2" />
                                </div>
                                <div className="div-8">
                                    <div className="name-and-supporting">
                                        <div className="name-and-role">
                                            <div className="text-wrapper-13">
                                                Andreas Lachner
                                            </div>
                                            <p className="role">
                                                Co-Direktor des Tübingen Center
                                                for Digital Education (TüCeDE)
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="quote-2"
                                data-breakpoint-mode="dekstop"
                            >
                                <p className="paragraph">
                                    Forschung und Praxis liegt mir sehr am
                                    Herzen. Mit unserer Plattform duo möchten
                                    wir einen Beitrag leisten, dass digitale
                                    Technologien wirksam im Unterricht
                                    eingesetzt werden. Uns ist dabei ein
                                    ko-konstruktiver Austausch auf Augenhöhe
                                    sehr wichtig.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-2">
                <div className="content-5">
                    <div className="div-15">
                        <div className="div-11" id="what_awaits">
                            <p className="text-wrapper-11">
                                Das erwartet Sie auf DUO
                            </p>
                            <p className="text-wrapper-12">
                                Wir bieten Informationstexte und Materialien an,
                                die den effektiven Unterricht mit und über
                                digitalen Medien erklären, ermöglichen und
                                exemplifizieren:
                            </p>
                        </div>
                        <div className="div-13">
                            <CtaBlock
                                className="design-component-instance-node-3"
                                showLink={false}
                                stateProp="default"
                                style="default"
                                text="Alle unsere Materalien sind Open Educational Resources (frei für die Nutzung und Weitergabe). Bildung soll frei und zugänglich sein - und das ist sie bei uns!"
                                title="Kostenlose Bildungsmaterialien"
                            />
                            <CtaBlock
                                className="design-component-instance-node-3"
                                showLink={false}
                                stateProp="default"
                                style="default"
                                text="Wir bündeln digitalisierungsbezogene Forschungsbefunde zum Lehren und Lernen. Dabei steht der Nutzen für die Praxis in unserem Fokus."
                                title="Aktuelle & relevante Forschungsbefunde für die Praxis "
                            />
                            <CtaBlock
                                className="design-component-instance-node-3"
                                showLink={false}
                                stateProp="default"
                                style="default"
                                text="Hier finden Sie aktuelle Fortbildungsangebote und Veranstaltungen zu digitalisierungsbezogenen Themen."
                                title="Übersicht über digitalisierungsbezogene Angebote"
                            />
                        </div>
                        {/* <div className="div-14"> */}
                        {/*<CtaBlock
                  className="design-component-instance-node-3"
                  showLink={false}
                  stateProp="default"
                  style="default"
                  text="Unsere Richtlinien und Protokolle sind kein Geheimnis! Wir setzen auf Transparenz, damit Sie genau wissen, wie wir die besten Materialien auswählen und erstellen."
                  title="Durchblick durch Transparenz"
                />
                <CtaBlock
                  className="design-component-instance-node-3"
                  showLink={false}
                  stateProp="default"
                  style="default"
                  text="Alle unsere Materialien sind unter der Lizenz CC BY-SA – (Namensnennung, Weitergabe unter gleichen Bedingungen) veröffentlicht. Bildung soll frei und zugänglich sein – und das ist sie bei uns!"
                  title="Bildungsmaterialien für alle – Kostenlos und offen"
                />
				*/}
                        {/* </div> */}
                    </div>

                    {/*
          <div className="div-10">
            <div className="div-11">
              <p className="text-wrapper-14">
                Tauchen Sie ein, lassen Sie sich inspirieren und gestalten Sie mit uns die Zukunft der Bildung! Hier
                geht es nicht nur um Informationen, sondern um eine lebendige Gemeinschaft, die gemeinsam wächst und
                sich entwickelt. Ihre Reise zu neuen pädagogischen Horizonten beginnt JETZT!
              </p>
            </div>
          </div>
		*/}
                </div>
            </div>

            <div className="team-section">
                <div className="content-5">
                    <div className="heading-and">
                        <div className="heading-wrapper">
                            <p className="text-wrapper-11">Unserer Team</p>
                        </div>
                        {/*<p className="supporting-text-2">
                      Unser Team im Fokus: Treiber der Bildungsinnovation! Lernen Sie die kreativen Köpfe hinter unserem
                      Projekt kennen, die sich leidenschaftlich der Neugestaltung der Bildung widmen.
                    </p>
					*/}
                    </div>

                    <div className="div-15">
                        <div className="content-6">
                            <div className="team-member">
                                <div className="image-wrapper">
                                    <div className="image-2" />
                                </div>
                                <div className="div-8">
                                    <div className="name-and-supporting">
                                        <div className="name-and-role">
                                            <div className="text-wrapper-13">
                                                Andreas Lachner
                                            </div>
                                            <p className="role-2">
                                                Co-Direktor des Tübingen Center
                                                for Digital Education (TüCeDE)
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="team-member">
                                <div className="image-3">
                                    <div className="image-2" />
                                </div>
                                <div className="div-8">
                                    <div className="name-and-supporting">
                                        <div className="name-and-role">
                                            <div className="text-wrapper-13">
                                                Thérése F. Eder
                                            </div>
                                            <p className="role-2">
                                                Leitung des Arbeitsbereichs
                                                Transfer und
                                                Professionalisierung
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="team-member">
                                <div className="image-5">
                                    <div className="image-2" />
                                </div>
                                <div className="div-8">
                                    <div className="name-and-supporting">
                                        <div className="name-and-role">
                                            <div className="text-wrapper-13">
                                                Stephen Bodnar
                                            </div>
                                            <p className="role-2">
                                                Leitung des Arbeitsbereichs
                                                Software Development
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="team-member">
                                <div className="image-6">
                                    <div className="image-2" />
                                </div>
                                <div className="div-8">
                                    <div className="name-and-supporting">
                                        <div className="name-and-role">
                                            <div className="text-wrapper-13">
                                                Marcel Capparozza
                                            </div>
                                            <p className="role-2">
                                                Wissenschaftlicher Mitarbeiter
                                                des Tübingen Center for Digital
                                                Education (TüCeDE)
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="team-member">
                                <div className="image-8">
                                    <div className="image-2" />
                                </div>
                                <div className="div-8">
                                    <div className="name-and-supporting">
                                        <div className="name-and-role">
                                            <div className="text-wrapper-13">
                                                Martí Quixal
                                            </div>
                                            <p className="role-2">
                                                Wissenschaftlicher Mitarbeiter
                                                des Tübingen Center for Digital
                                                Education (TüCeDE)
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="team-member">
                                <div className="image-9">
                                    <div className="image-2" />
                                </div>
                                <div className="div-8">
                                    <div className="name-and-supporting">
                                        <div className="name-and-role">
                                            <div className="text-wrapper-13">
                                                Franziska Gazar, née Tschönhens
                                            </div>
                                            <p className="role-2">
                                                Wissenschaftliche Mitarbeiterin
                                                des Tübingen Center for Digital
                                                Education (TüCeDE)
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer
                className="design-component-instance-node-3"
                property1="desktop"
            />
        </div>
    );
};
